import React,{Fragment} from "react";
import Modal from "../../layout/Modal";
import PropTypes, {ReactComponentLike} from "prop-types";
import Button, {ButtonProps} from "../Button";
import Portal from "../../layout/Portal";

type AskBeforeUnloadProps = {
    buttons?: (ButtonProps|ReactComponentLike)[],
    saveable?: boolean,
    resolve: (reason?: any) => void,
    reject: (reason?: any) => void,
};

class AskBeforeDelete extends React.Component<AskBeforeUnloadProps, {isLoading: boolean}> {

    state = {
        isLoading: false
    }

    static propTypes = {
        buttons: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
    }

    render() {
        return <Portal>
            <Modal
                state="on"
                theme="default"
                header="Törlés"
                buttons={this.props.buttons || [
                    <Button
                        color="danger"
                        timeout={3}
                        onClick={async () => {
                            this.setState({isLoading: true});
                            await this.props.resolve();
                            this.setState({isLoading: false});
                        }}
                    >
                        Törlés
                    </Button>,
                    <Button
                        color="default"
                        onClose={true}
                        onClick={async () => {
                            this.setState({isLoading: true});
                            await this.props.reject();
                            this.setState({isLoading: false});
                        }}
                    >
                        Mégse
                    </Button>,
                ]}
            >
                Biztosan törlöd ezt a tételt?
            </Modal>
        </Portal>;
    }
}
export default AskBeforeDelete;